if((typeof Shopify) === 'undefined'){ window.Shopify = {}; }
if((typeof Shopify.getCart) === 'undefined'){
  Shopify.getCart = function(callback, cart){
    if(!cart){
      return jQuery.getJSON('/cart.js', function(cart, textStatus, xhr){
        if((typeof callback) === 'function'){
          callback(cart, textStatus, xhr);

        } else {
          Shopify.onCartUpdate(cart);

        }
      });
    } else {
      if((typeof callback) === 'function'){
        callback(cart);

      } else if(typeof Shopify.onCartUpdate === 'function'){
        Shopify.onCartUpdate(cart);
      }
    }
  };
}


$('#product-select').on('change', function() {
  console.log( this.value );
  $('.ajax-cart--trigger-add-upsell').data('id', this.value);
});


Shopify.AjaxCart = {

settings: {
  // cartTotalPrice: ,
  vat_rate: 20,
  shippingPrice: 1200,
  shippingPriceDisplay: '$12.00',
  freeShippingThreshold: 12500,
},

	translations: {
		"title": "Bag",
		"cart": {
			"empty_cart": "",
			"loading": "Loading"
		},
		"shipping_banner": {
			"text_required_html": "Spend SHIPPING_PRICE more to get free shipping",
			"text_free_html": "Congrats! You qualify for free shipping."
		},
		"cart_notes": {
			"title": "Order Notes",
			"view_terms": "View terms",
			"agree_to_terms": "I agree with the terms and conditions."
		},
		"statement": {
			"label_shipping": "Shipping",
			"label_savings": "Savings",
			"label_subtotal": "Subtotal",
			"label_total": "Total"
		},
		"buttons": {
			"cart": "TODO",
			"checkout": "Check Out"
		}
	},

	storage: {

		cart: null

	},

	api: {

		addItem: function(options){

			var settings = $.extend({}, options);

			var quantity = settings.quantity;
			var id = settings.id;

			var data = {
				quantity: quantity,
				id: id
			};

			$.ajax({
				url: '/cart/add.js',
				type: 'post',
				dataType: 'json',
				data: data,
				beforeSend: function(){

					Shopify.AjaxCart.functions.cartOverlayShow();

					$("#ajax-cart").trigger("ajax-cart.add-item.before");

					if (typeof settings.beforeSend === 'function') {
						settings.beforeSend();
					}

				},
				error: function(){

					Shopify.AjaxCart.functions.cartOverlayHide();

					$("#ajax-cart").trigger("ajax-cart.add-item.error");

					if (typeof settings.error === 'function') {
						settings.error();
					}

				},
				success: function (data) {

					Shopify.AjaxCart.api.updateCart();

					$("#ajax-cart").trigger("ajax-cart.add-item.success");

					if (typeof settings.success === 'function') {
						settings.success();
					}

				}
			});

		},

		changeItemQuantity: function(options){

			var settings = $.extend({}, options)

			var quantity = settings.quantity;
			var id = settings.id;

			var data = {
				quantity: quantity,
				id: id
			};

			$.ajax({
				url: '/cart/change.js',
				dataType: 'json',
				cache: false,
				type: 'post',
				data: data,
				error: function(){

					Shopify.AjaxCart.functions.cartOverlayHide();

					$("#ajax-cart").trigger("ajax-cart.change-item.error", [data]);

					if (typeof settings.error === 'function') {
						settings.error();
					}

				},
				beforeSend: function(){

					Shopify.AjaxCart.functions.cartOverlayShow();

					$("#ajax-cart").trigger("ajax-cart.change-item.before", [data]);

					if (typeof settings.beforeSend === 'function') {
						settings.beforeSend();
					}

				},
				success: function (data) {

					Shopify.AjaxCart.api.updateCart();

					$("#ajax-cart").trigger("ajax-cart.change-item.success", [data]);

					if (typeof settings.success === 'function') {
						settings.success();
					}

				}
			});

		},

		updateCart: function(options){

			var settings = $.extend({}, options)

			$.ajax({
				url: '/cart.js',
				dataType: "json",
				cache: false,
				error: function(){

					Shopify.AjaxCart.functions.cartOverlayHide();

					$("#ajax-cart").trigger("ajax-cart.update-cart.error");

					if (typeof settings.error === 'function') {
						settings.error();
					}

				},
				beforeSend: function(){

					Shopify.AjaxCart.functions.cartOverlayShow();

					$("#ajax-cart").trigger("ajax-cart.update-cart.before");

					if (typeof settings.beforeSend === 'function') {
						settings.beforeSend();
					}

				},
				complete: function(){

					Shopify.AjaxCart.functions.cartOverlayHide();

					if (typeof settings.complete === 'function') {
						settings.complete();
					}

				},
				success: function(data){
					Shopify.AjaxCart.storage.cart = data;
					Shopify.AjaxCart.functions.refreshShipping();
					Shopify.AjaxCart.functions.refreshCart();
					Shopify.AjaxCart.functions.refreshTotals();
				  
					$("#ajax-cart").trigger("ajax-cart.update-cart.success", [data]);
					if (typeof settings.success === 'function') settings.success(data);
				  }
			});

		}

	},

	templates: {

		cartItem: function(data){

			///console.log(data);

			var id = data.id;
			var image = data.image;
			var title = data.product_title;
			var price = data.price;
			var price_formatted = Shopify.formatMoney(price, $('form').data('money-format'));

			var quantity = data.quantity;
			var url = data.url;
			var variants = data.variant_options;

			var html = "";

			html +=  '<div class="ajax-cart-item" data-id="' + id + '">';
			html +=    '<div class="ajax-cart-item__image">';

			if (image) {
			html +=        '<a href="' + url + '">';
			html +=          '<img src="' + image + '" alt="' + title + '"/>';
			html +=        '</a>';
			}

			html +=    '</div>';

			html +=    '<div class="ajax-cart-item__properties">';
			html +=      '<a class="ajax-cart-item__link" href="' + url + '">';
			html +=        '<div class="ajax-cart-item__title">' + title + '</div>';
			html +=      '</a>';
			html += '<span class="ajax-cart-item__price">';

					var moneyFormat = Shopify.AjaxCart.moneyFormat || $('form').data('money-format');

					// Per-unit prices (these reflect cart-level discounts too via allocations)
					var unitFinal = (typeof data.final_price === 'number') ? data.final_price : data.price;
					var unitOriginal = (typeof data.original_price === 'number') ? data.original_price : data.price;

					var unitFinalFormatted = Shopify.formatMoney(unitFinal, moneyFormat);
					var unitOriginalFormatted = Shopify.formatMoney(unitOriginal, moneyFormat);

					var hasDiscount = unitFinal < unitOriginal;

					if (hasDiscount) {
					html += '<span class="money sale_price">' + unitFinalFormatted + '</span>';
					html += '<span class="money was_price">' + unitOriginalFormatted + '</span>';
					} else {
					html += '<span class="money">' + unitOriginalFormatted + '</span>';
					}

html += '</span>';
			html +=      '<div class="ajax-cart-item__variants">';

			if (variants[0] !== "Default Title") {
				for (var i = 0; i < variants.length; i++) {
					if (i === variants.length - 1) {
        			html += variants[i];
    			} else {
							html += variants[i] + ' | ';
					}
				}
			}

			/*
			html +=          '';
			html +=            '';
			html +=          '';
			html +=          '';
			*/
			html +=      '<span tabindex="0" class="ajax-cart-item__remove"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="presentation" class="icon icon-remove"><path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path><path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path></svg></span></div>';
			html +=      '<div class="ajax-cart-quantity-selector">';
			html +=        '<span class="ajax-cart-quantity-selector__button ajax-cart-quantity-selector__decrement"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" fill="none" viewBox="0 0 10 2"><path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></path></svg></span>';
			html +=        '<input class="quantity__input ajax-cart-quantity-selector__quantity" type="number" min="0" size="2" name="updates[]" id="updates_' + id + '" value="' + quantity + '" data-line-id=""/>';
			html +=        '<span class="ajax-cart-quantity-selector__button ajax-cart-quantity-selector__increment"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" fill="none" viewBox="0 0 10 10"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path></svg></span>';
			html +=      '</div>';
			html +=    '</div>';
			html +=  '</div>';

			return html;

		},

		cartEmptyMessage: function(){

			var html = "";

			html += '<div class="ajax-cart-empty-message">';
			html +=   '<span class="ajax-cart-empty-message__icon"></span>';
			html +=   '<span class="ajax-cart-empty-message__text">' + Shopify.AjaxCart.translations.cart.empty_cart + '</span>';
			html += '</div>';

			return html;

		},

		cartContentsOverlay: function(options){

			var text = Shopify.AjaxCart.translations.cart.loading;

			if (typeof options != "undefined") {
				if (typeof options.text === "string") {
					text = options.text;
				}
			}

			var html = "";

			html +=  '<div class="ajax-cart-contents-overlay">';
			html +=    '<div class="ajax-cart-contents-overlay__content">';
			html +=      '<div class="ajax-cart-contents-overlay__icon animation--pulse"><img class="d-none" src="//losangelesapparel.net/cdn/shop/t/241/assets/ajax-cart-loading.svg?v=84242296345956001421788473558" alt="Loading..." /></div>';
			// html +=      '<div class="ajax-cart-contents-overlay__text">Loading...</div>';
			html +=    '</div>';
			html +=  '</div>';

			return html;

		},

	},

	functions: {

		cartToggle: function(e){

			var open = $('.ajax-cart').hasClass('ajax-cart--opened') === true;

			if (open === true) {
				Shopify.AjaxCart.eventHandlers.cartClose();
			}
			else {
				Shopify.AjaxCart.eventHandlers.cartOpen();
			}

		},

		cartOpen: function(e){
			

			$(".ajax-cart")
				.addClass('ajax-cart--opened')
				.removeClass('ajax-cart--closed');

			$(".ajax-cart-overlay").fadeIn();

			$("#ajax-cart").trigger("ajax-cart.cart-open");

			$("body").addClass("ajax-cart--lock-scroll");

			// Add the tracking code here
    	fetch("/cart.js")
        .then(response => response.json())
        .then(cart => {
            if (typeof Shopify !== 'undefined' && Shopify.analytics && Shopify.analytics.publish) {
                Shopify.analytics.publish("custom_cart_viewed", { data: cart });
				
            }
        })
        .catch(error => {
            console.error('Error fetching cart for analytics:', error);
        });


		},

		cartClose: function(){

			$(".ajax-cart")
				.removeClass('ajax-cart--opened')
				.addClass('ajax-cart--closed');

			$(".ajax-cart-overlay").fadeOut();

			$("#ajax-cart").trigger("ajax-cart.cart-close");

			$("body").removeClass("ajax-cart--lock-scroll");

		},

		cartOverlayShow: function(){

			if ( $('.ajax-cart .ajax-cart__body .ajax-cart-contents-overlay').length > 0 ) {
				return;
			}

			var overlay = Shopify.AjaxCart.templates.cartContentsOverlay({ text: "Cart Loading..." });
			var container = $('.ajax-cart .ajax-cart__body');

			overlay = $(overlay)[0];

			container.prepend(overlay);

		},

		cartOverlayHide: function(){

			var overlay = $('.ajax-cart .ajax-cart__body .ajax-cart-contents-overlay');

			$(overlay).remove();

		},

		refreshShipping: function(){
			
			var enableFreeShipping = true;
			
			var freeShipping = (Shopify.AjaxCart.storage.cart.total_price >= Shopify.AjaxCart.settings.freeShippingThreshold && enableFreeShipping === true) ? true : false;
			var shippingBannerText;

			if (freeShipping === true) {

				$('.ajax-cart-banner').addClass('ajax-cart-banner--success');

				shippingBannerText = Shopify.AjaxCart.translations.shipping_banner.text_free_html;

			}
			else {

				$('.ajax-cart-banner').removeClass('ajax-cart-banner--success');

				var moneyFormat = $('form').data('money-format');

				var shippingPriceDifference = Shopify.AjaxCart.settings.freeShippingThreshold - Shopify.AjaxCart.storage.cart.total_price;
				var shippingPriceDifferenceDisplay = Shopify.formatMoney(shippingPriceDifference, moneyFormat);

				shippingBannerText = Shopify.AjaxCart.translations.shipping_banner.text_required_html;
				shippingBannerText = shippingBannerText.replace("SHIPPING_PRICE", shippingPriceDifferenceDisplay)

			}

			$('.ajax-cart-banner__text').html(shippingBannerText);

		},

		refreshCart: function(){

			var cartCount = Shopify.AjaxCart.storage.cart.item_count;
			var cartItems = Shopify.AjaxCart.storage.cart.items;
			var cartContainer = $('.ajax-cart__items');

			if (cartItems.length > 0) {
				showCartItems();
			}
			else {
				showEmptyMessage();
			}

			$('[data-ajaxcart-value]').text(cartCount);
			$('.cart-count-bubble').text(cartCount);
			function showEmptyMessage() {

				var html = Shopify.AjaxCart.templates.cartEmptyMessage();

				cartContainer.html(html);

			}

			function showCartItems() {

				var html = "";

				for (var i = 0; i < cartItems.length; i++) {
					html += Shopify.AjaxCart.templates.cartItem(cartItems[i]);
				}

				cartContainer.html(html);

			}

		},

		captureDiscountCodeFromUrl: function(){
			try {
			  var path = window.location.pathname || '';
			  var m = path.match(/\/discount\/([^\/\?]+)/i);
			  if (m && m[1]) {
				var code = decodeURIComponent(m[1]).trim();
				if (code) localStorage.setItem('ajaxcart_discount_code', code);
			  }
			} catch(e) {}
		  },
		  
		  getStoredDiscountCode: function(){
			try {
			  return localStorage.getItem('ajaxcart_discount_code') || '';
			} catch(e) {
			  return '';
			}
		  },

		

		refreshTotals: function(){

			var moneyFormat = $('form').data('money-format');
		  
			
			var enableFreeShipping = true;
			
		  
			var cart = Shopify.AjaxCart.storage.cart;
		  
			var shippingIsFree = (cart.total_price >= Shopify.AjaxCart.settings.freeShippingThreshold && enableFreeShipping === true) ? true : false;
			var shippingPriceLabel = '';
		  
			var lineShipping = $('.ajax-cart-statement-line--shipping .ajax-cart-statement-line__value');
			var lineSavings  = $('.ajax-cart-statement-line--savings');
			var lineVat      = $('.ajax-cart-statement-line--vat .ajax-cart-statement-line__value');
			var lineSubtotal = $('.ajax-cart-statement-line--subtotal .ajax-cart-statement-line__value');
			var lineTotal    = $('.ajax-cart-statement-line--total .ajax-cart-statement-line__value');
		  
			// SHIPPING
			var valueShipping = (shippingIsFree === true || shippingPriceLabel !== "") ? 0 : Shopify.AjaxCart.settings.shippingPrice;
			var valueShippingDisplay = Shopify.AjaxCart.settings.shippingPriceDisplay;
		  
			// SUBTOTALS (IMPORTANT)
			// original_total_price = before discounts; total_price = after discounts
			var originalSubtotal = (typeof cart.original_total_price === 'number') ? cart.original_total_price : (cart.total_price + (cart.total_discount || 0));
			var discountedSubtotal = cart.total_price;
			var totalDiscount = (typeof cart.total_discount === 'number') ? cart.total_discount : (originalSubtotal - discountedSubtotal);
		  
			// VAT (keep your behavior: VAT on discounted subtotal)
			var vatRate = Shopify.AjaxCart.settings.vat_rate || 0;
			var valueVat = (discountedSubtotal * (vatRate / 100));
		  
			// TOTAL (after discounts)
			var valueTotal = discountedSubtotal + valueShipping + valueVat;
		  
			// DISPLAY STRINGS
			var displaySubtotal = Shopify.formatMoney(originalSubtotal, moneyFormat);
			var displayTotal    = Shopify.formatMoney(valueTotal, moneyFormat);
			var displayVat      = Shopify.formatMoney(valueVat, moneyFormat);
		  
			// Render subtotal
			lineSubtotal.html(displaySubtotal);
		  
			// Render VAT
			lineVat.html(displayVat);
		  
			// Render shipping
			var displayShipping;
			if (shippingPriceLabel != "") {
			  displayShipping = '<span class="ajax-cart-statement-line__shipping-label">' + shippingPriceLabel + '</span>';
			} else if (shippingIsFree === true || valueShipping === 0) {
			  displayShipping = '<span class="ajax-cart-statement-line__free-shipping">Free</span>';
			} else if (valueShipping > 0) {
			  displayShipping = '<span class="ajax-cart-statement-line__shipping-price">' + valueShippingDisplay + '</span>';
			} else {
			  displayShipping = '';
			}
			lineShipping.html(displayShipping);
		  
			// Render total
			lineTotal.html(displayTotal);
		  
			// ---------- DISCOUNT LINES (code/title + amount) ----------
			var $discountLines = $('.ajax-cart-discount-lines');
			$discountLines.empty();
		  
			function escapeHtml(str){
			  return String(str)
				.replace(/&/g, '&amp;')
				.replace(/</g, '&lt;')
				.replace(/>/g, '&gt;')
				.replace(/"/g, '&quot;')
				.replace(/'/g, '&#039;');
			}
		  
			function renderDiscountRow(label, amountCents){
			  var amountFormatted = Shopify.formatMoney(amountCents, moneyFormat);
			  return (
				'<div class="ajax-cart-statement-line ajax-cart-statement-line--discount">' +
				  '<span class="ajax-cart-statement-line__label">' +
					escapeHtml(label) +
				  '</span>' +
				  '<span class="ajax-cart-statement-line__value">-' + amountFormatted + '</span>' +
				'</div>'
			  );
			}
		  
			// Build discount map by application index (preferred, because it matches Shopify’s own breakdown)
			var hasRenderedDiscountLines = false;
		  
			if (Array.isArray(cart.items) && Array.isArray(cart.discount_applications) && cart.discount_applications.length) {
			  var totalsByIndex = {};
			  cart.items.forEach(function(item){
				(item.discount_allocations || []).forEach(function(da){
				  var idx = da.discount_application_index;
				  var amt = parseInt(da.amount, 10) || 0;
				  totalsByIndex[idx] = (totalsByIndex[idx] || 0) + amt;
				});
			  });
		  
			  cart.discount_applications.forEach(function(app, idx){
				var amt = totalsByIndex[idx] || 0;
				if (amt > 0) {
				  $discountLines.append(renderDiscountRow(app.title || 'Discount', amt));
				  hasRenderedDiscountLines = true;
				}
			  });
			}
		  
			// Fallback: if Shopify didn’t give us discount_applications but there IS a discount,
			// show a single line using stored code (from /discount/CODE) or generic "Discount".
			if (!hasRenderedDiscountLines && totalDiscount > 0) {
			  var storedCode = Shopify.AjaxCart.functions.getStoredDiscountCode && Shopify.AjaxCart.functions.getStoredDiscountCode();
			  var label = storedCode || 'Discount';
			  $discountLines.append(renderDiscountRow(label, totalDiscount));
			  hasRenderedDiscountLines = true;
			}
		  
			if (hasRenderedDiscountLines) {
			  $discountLines.show();
			  // Hide your old "Savings" line so you don’t show discount twice
			  lineSavings.hide();
			} else {
			  $discountLines.hide();
			  lineSavings.show();
			}
		  
		  },
		  

		addEventListeners: function() {

			$('.ajax-cart__items').on("click", '.ajax-cart-item__remove', Shopify.AjaxCart.eventHandlers.itemRemove);
			$('.ajax-cart__items').on("click", '.ajax-cart-quantity-selector__increment', Shopify.AjaxCart.eventHandlers.onClickItemIncrement);
			$('.ajax-cart__items').on("click", '.ajax-cart-quantity-selector__decrement', Shopify.AjaxCart.eventHandlers.onClickItemDecrement);
			$('.ajax-cart__items').on("change", '.ajax-cart-quantity-selector__quantity', Shopify.AjaxCart.eventHandlers.onChangeItemQuantity);

			$('body').on("click", ".ajax-cart-overlay", Shopify.AjaxCart.eventHandlers.onClickCartClose);

			$('body').on('click', '.ajax-cart--trigger-open', Shopify.AjaxCart.eventHandlers.onClickCartOpen);
			$('body').on('click', '.ajax-cart--trigger-close', Shopify.AjaxCart.eventHandlers.onClickCartClose);
			$('body').on('click', '.ajax-cart--trigger-toggle', Shopify.AjaxCart.eventHandlers.onClickCartToggle);
			$('body').on("click", '.ajax-cart--trigger-submit', Shopify.AjaxCart.eventHandlers.onClickCheckout);
			$('body').on("click", '.ajax-cart--trigger-gotocart', Shopify.AjaxCart.eventHandlers.onClickGoToCart);
			$('body').on("click", '.ajax-cart--trigger-add-upsell', Shopify.AjaxCart.eventHandlers.onClickAddUpsell);

		}

	},

	eventHandlers: {

		onClickGoToCart: function(){
			location.href = '/cart';
		},

		onClickCheckout: function(e){

			e.preventDefault();

			$('.ajax-cart__form').submit();

		},

		onClickCartOpen: function(e){

			e.preventDefault();

			if ( $("body").hasClass("cart") === true ) {
				return;
			}

			Shopify.AjaxCart.functions.cartOpen();

		},

		onClickCartClose: function(e){

			e.preventDefault();
			Shopify.AjaxCart.functions.cartClose();

		},

		onClickCartToggle: function(e){

			e.preventDefault();
			Shopify.AjaxCart.functions.cartToggle();

		},

		onClickAddUpsell: function(e){

			var button = $(e.currentTarget);
			var upsell = button.closest(".ajax-cart-upsell__plus");
			var id = upsell.data("id");
      console.log(upsell);
			var options = {
				id: id,
				quantity: 1,
			};

			Shopify.AjaxCart.api.addItem(options);

		},

		onClickItemIncrement: function(e){

			var button = $(e.currentTarget);
			var selector = button.closest('.ajax-cart-quantity-selector');
			var input = selector.find('.ajax-cart-quantity-selector__quantity');
			var value = input.val();

			value++;
			input.val(value);

			input.trigger("change");

		},

		onClickItemDecrement: function(e){

			var button = $(e.currentTarget);
			var selector = button.closest('.ajax-cart-quantity-selector');
			var input = selector.find('.ajax-cart-quantity-selector__quantity');
			var value = input.val();

			value--;
			input.val(value);

			input.trigger("change");

		},

		onChangeItemQuantity: function(e){

			var input = $(e.currentTarget);
			var item = input.closest(".ajax-cart-item");
			var id = item.data("id");
			var quantity = input.val();

			Shopify.AjaxCart.api.changeItemQuantity({
				id: id,
				quantity: quantity
			});

		},

		itemRemove: function(e){

			var input = $(e.currentTarget);
			var item = input.closest(".ajax-cart-item");
			var id = item.data("id");
			var quantity = input.val();

			Shopify.AjaxCart.api.changeItemQuantity({
				id: id,
				quantity: 0
			});

		}

	},

	init: function(){
		Shopify.AjaxCart.functions.captureDiscountCodeFromUrl();
		Shopify.AjaxCart.functions.addEventListeners();
		Shopify.AjaxCart.api.updateCart();

	}

};

Shopify.AjaxCart.init();
